import { IGeoPos, GeoPos } from '../geographicalpos/geographicalpos.model';

export interface IUserState {
  current: IUser;
  list: Array<IUser>;
}

export interface IUser {
  id: any;
  name?: string;
  auth_user?: string;
  geopos?: Array<IGeoPos>;
  isadmin?: boolean;
  password?: string;
}

export const USER_STATE = {
  current: null,
  list: []
};

export class User implements IUser {
  id: any;
  name?: string;
  auth_user?: string;
  geopos?: Array<IGeoPos>;
  isadmin?: boolean;
  password?: string;

    constructor(obj: IUser = {} as IUser) {
        const {
          id= null,
          name= '',
          auth_user= '',
          geopos= [],
          isadmin= false,
          password= ''
        } = obj;

        this.id = id,
        this.name = name,
        this.auth_user = auth_user,
        this.geopos = geopos,
        this.isadmin = isadmin,
        this.password = password;
    }

    static from(obj): IUser {
      return new User({
        id : obj.iduser,
        name : obj.name,
        auth_user : obj.auth_user,
        geopos : GeoPos.fromArray(obj.geographicalpos),
        isadmin : obj.isadmin,
        password : obj.password
      });
    }
    static fromArray(list) {
      if (!list || !(list instanceof Array)) {
          return [];
      }
      return list.map(User.from).filter(item => item != null);
    }

    static to(obj) {
      return {
        iduser : obj.id,
        name : obj.name,
        auth_user : obj.auth_user,
        geographicalpos : GeoPos.toArray(obj.geopos),
        isadmin : obj.isadmin,
        password : obj.password
      };
    }

    static toArray(list) {
        if (!list || !(list instanceof Array)) {
            return [];
        }
        return list.map(User.to).filter(item => item != null);
    }
}
